import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement
} from "react-vertical-timeline-component";
import 'react-vertical-timeline-component/style.min.css';
import { FaBriefcase } from "react-icons/fa";

const experiences = [
  {
    company: "Finsall Resources Pvt Ltd",
    role: "Senior Software Engineer",
    duration: "Apr 2025 – Present",
    points: [
      "Migrated external loan apps from Angular to React 18, reducing page load by 30% and boosting developer productivity.",
      "Built a secure Finance Portal with Angular by automating 80% of manual workflows, eliminating human error.",
      "Refactored complex form state management using Context + Reducer pattern to improve performance and debugging.",
      "Implemented GitHub Actions + Docker CI/CD with feature toggles for zero-downtime deployments."
    ]
  },
  {
    company: "Finsall Resources Pvt Ltd",
    role: "Frontend Developer",
    duration: "Aug 2023 – Mar 2025",
    points: [
      "Led migration of internal apps from Angular to React 18, cutting maintenance effort by 35%.",
      "Implemented AES + SHA256 encryption algorithms to secure data.",
      "Architected loan onboarding flows, boosting completion rate by 20%.",
      "Upgraded Angular from v10 to v17 to improve tooling and performance.",
      "Integrated Cashfree & Razorpay, handling ₹2Cr+ secure monthly transactions.",
      "Built Aadhaar-based facial liveness/match module, reducing fraud by 50%.",
      "Automated eNACH/eSign with Digio & Cashfree SDKs, cutting paperwork by 90%.",
      "Created multilingual HTML-PDF templates, saving ₹50K/month in translation.",
      "Built encrypted APIs for client-server communication—zero data breaches.",
      "Delivered Loan Ops dashboard with embedded PDF viewer for KYC verification.",
      "Added CRM chat module, reducing support turnaround time by 25%.",
      "Built dev utility dashboard with live SQL viewer & encryption tools—debug speed improved 3×."
    ]
  },
  {
    company: "Exozen Smart Society Pvt Ltd",
    role: "Frontend Developer",
    duration: "Aug 2022 – Aug 2023",
    points: [
      "Built Angular dashboards for real-time apartment-wise water usage tracking—reducing waste by 15%.",
      "Revamped SSDP UI using Angular Material, doubling engagement and load performance.",
      "Visualized consumption data through charts to support decision-making.",
      "Secured platform via JWT-based role-based access control."
    ]
  }
];

export function ExperienceTimeline() {
  return (
    <VerticalTimeline lineColor="#CD5FF8">
      {experiences.map((exp, index) => (
        <VerticalTimelineElement
          key={index}
          className="vertical-timeline-element-work"
          date={exp.duration}
          iconStyle={{ background: "#6c63ff", color: "#fff" }}
          icon={<FaBriefcase />}
          contentStyle={{
            background: "#813499",
            color: "#fff", // Ensures text is visible
            borderTop: "4px solid #6c63ff",
            boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
          }}
          contentArrowStyle={{ borderRight: "7px solid #fff" }}
        >
          <h3 className="vertical-timeline-element-title">{exp.role}</h3>
          <h4 className="vertical-timeline-element-subtitle">{exp.company}</h4>
          <ul>
            {exp.points.map((point, idx) => (
              <li key={idx}>{point}</li>
            ))}
          </ul>
        </VerticalTimelineElement>
      ))}
    </VerticalTimeline>
  );
}
